export default "__VITE_ASSET__CO$szf5P__"